module.exports = __webpack_public_path__ + "static/media/hp.9a3a10ba.png";